import React,{useRef,useState} from 'react';
import { Modal } from 'react-responsive-modal';

const UpdateAddressForm = ({isAddress,onClickAction}) => {
    const [open, setOpen] = useState(true);
    const onCloseModal = () => setOpen(false);
    const onClickPopUPBtn  = (e, actionName) => {
        
        if(actionName=='Yes'){
            onCloseModal();
        }
        onClickAction(e, actionName);
    };
    const modalRef = useRef(null);
    return(
        <>
        { (['/e911/updateaddress/', '/e911/updateaddress'].includes(isAddress) && open) &&
        <div>
            <Modal classNames={{ modal: 'updateaddress-modal'}} ref={modalRef} initialFocusRef={modalRef} closeOnOverlayClick={false} open={open} center onClose={onCloseModal}>
                <div className="modal-wrapper updateaddress">
                    <h3>It appears that your registered location is not accurate for 911 emergencies.</h3>
                    <div className="msg">Would you like to update your registered location?</div>
                    <div className="primary">
                        <button type="button" title="Yes" onClick={(e)=>{ onClickPopUPBtn(e, 'Yes')}} className="action submit primary-btn">
                            <span>Yes</span>
                        </button>
                        <button type="button" title="No" onClick={(e)=>{ onClickPopUPBtn(e, 'No')}} className="action submit primary-btn">
                            <span>No</span>
                        </button>
                    </div>
                </div>              
            </Modal>
            </div>
        }
        </> 
    );
}

export default UpdateAddressForm;